/**
 * レイアウト変更のしきい値
 */
export const BREAK_POINT = 1024
